import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

export const GroupedMenuHeader = (props) => {
	const {
		className,
		children
	} = props;

	return (
		<div className={classNames(className, 'ads-grouped-menu-header')}>{children}</div>
	);
}

GroupedMenuHeader.propTypes = {
	children: PropTypes.node.isRequired,
	className: PropTypes.string,
};

GroupedMenuHeader.defaultProps = {
	className: '',
};
